import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'rms-ui';
  constructor(private permissionsService: NgxPermissionsService, private ngxRolesService: NgxRolesService) { }
  user:any;

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser'))['user'] : '';
    let permissions = [];
    if(this.user && this.user.role){
      permissions.push(this.user.role.name);
      this.permissionsService.loadPermissions(permissions);
      console.log(permissions, this.permissionsService);

      this.ngxRolesService.addRoles({
        'RECRUITER': ['CreateInterview'],
        'ADMIN': ['CreateInterview', 'CreateJob', 'DeleteJob'],
        'SUPER_ADMIN': ['CreateTechnology', 'CreateInterview', 'CreateJob', 'DeleteJob'],
        'DEVELOPER': () => { return true; }
      });
    }
}
}